// Single source of truth for the bottom-tab shell.
//
// The tabs shell runs WITHOUT Ionic's `<ion-tab-bar>` — the visible nav is the
// design-system `BottomNav`, and switching is driven manually (see
// `src/pages/tabs/TabsPage.vue`). Three things have to agree on the identity of
// each tab, and used to be spelled out separately in each:
//
//   1. `TabsPage` — the tab list fed to `BottomNav` and the active-tab lookup.
//   2. Each tab page's `data-tab-root` marker — how `hideStaleTabPages` finds
//      the page to keep visible on a cross-in.
//   3. Each tab page's re-entry hook — which `value` it answers to (see
//      `src/mixins/TabReentry.js`).
//
// Keeping the value in one place makes the marker unable to drift from the tab
// list (issue #1487, ask 3): a page reads its identity from `TAB_VALUES`, so a
// rename here moves the list, the marker and the hook together.

export const TAB_VALUES = {
  HOME: 'home',
  LIBRARY: 'library',
  ALL: 'all',
  ME: 'me',
};

export const TAB_ITEMS = [
  {
    value: TAB_VALUES.HOME,
    route: '/tabs/home',
    label: 'Home',
    iconSrc: 'assets/icons/home-new.svg',
    iconAlt: 'Home',
  },
  {
    value: TAB_VALUES.LIBRARY,
    route: '/tabs/library',
    label: 'Library',
    iconSrc: 'assets/icons/library-new.svg',
    iconAlt: 'Library',
  },
  {
    value: TAB_VALUES.ALL,
    route: '/tabs/all',
    label: 'All',
    iconSrc: 'assets/icons/all-new.svg',
    iconAlt: 'All',
  },
  {
    value: TAB_VALUES.ME,
    route: '/tabs/me',
    label: 'Me',
    iconSrc: 'assets/icons/me-new.svg',
    iconAlt: 'Me',
  },
];

export const TAB_ROUTES = TAB_ITEMS.map(item => item.route);

// The set of legal `data-tab-root` / re-entry values, for validation.
export const TAB_VALUE_SET = new Set(TAB_ITEMS.map(item => item.value));

export function isKnownTabValue(value) {
  return TAB_VALUE_SET.has(value);
}
